export default __webpack_public_path__ + "components/page-header/static/mountain-forecast-outside__logo--white-1bbb9bac57637f08ee62c61f226b6ad8.png";